import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CustomerOTPDetailRBAC = {
  pageID: '77957aa47d129238de83b5cf4f8559b6',
  elementID: {
    View: '542904ea9af6735e736e72b6c9a12b41',
    Release: 'ba525ecb10ed43f2c1ee830cc1a6e5d9',
    ChangeReason: 'b51f4af30ec89fdf98dd5e90d5a055be',
  },
} as const

export const useRBACCustomerOTPDetailPage = createUseRBAC(CustomerOTPDetailRBAC.elementID)

export type UseRBACCustomerOTPDetailPageType = ReturnType<typeof useRBACCustomerOTPDetailPage>
